var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadioGroup from '@radix-ui/react-radio-group';
import { useEffect, useState } from 'react';
import { FormHelperText, styled, } from '@mui/material';
import { motion } from 'framer-motion';
import { useController } from 'react-hook-form';
import { cn } from 'hx-util';
export var CirclesSelect = function (_a) {
    var controllerProps = _a.controllerProps, labelProps = _a.labelProps, color = _a.color, options = _a.options, routeClass = _a.routeClass, itemStyles = _a.itemStyles, indicatorStyles = _a.indicatorStyles;
    var _b = useController(controllerProps), _c = _b.field, onChange = _c.onChange, value = _c.value, name = _c.name, error = _b.fieldState.error;
    var handleChange = function (value) {
        onChange(value);
    };
    return (_jsxs("div", __assign({ className: "grid place-items-center min-h-[10rem]" }, { children: [_jsx(RadioGroup.Root, __assign({ value: value, className: cn('grid grid-cols-3 gap-8', routeClass), onValueChange: handleChange }, { children: options.map(function (_a, index) {
                    var value = _a.value, label = _a.label, icon = _a.icon, onClick = _a.onClick;
                    return (_jsxs(AnimatedItem, __assign({ value: value, color: color, itemStyles: itemStyles, onClick: onClick }, { children: [_jsx(Indicator, { indicatorStyles: indicatorStyles }), _jsx(Icon, { children: icon }), _jsx(Label, __assign({}, labelProps, { children: label }))] }), "".concat(name, "-option-").concat(index)));
                }) })), error && _jsx(ErrorMessage, __assign({ error: true }, { children: error.message }))] })));
};
var Item = styled(RadioGroup.Item)(function (_a) {
    var theme = _a.theme, _b = _a.color, color = _b === void 0 ? theme.palette.primary.main : _b, styles = _a.styles;
    return (__assign({ '--circle-select-color': color, all: 'unset', width: 64, height: 64, borderRadius: '100%', border: "1px solid var(--circle-select-color)", display: 'grid', position: 'relative', gap: '1rem', boxShadow: "0 0 10px 4px #00000022", '&:focus': {
            borderWidth: '1px',
            borderColor: 'var(--circle-select-color)',
            borderStyle: 'solid',
            position: 'relative',
            '&:after': {
                content: '""',
                position: 'absolute',
                inset: '-5px',
                borderRadius: '100%',
                border: "1px solid var(--circle-select-color)",
            },
        }, '&[data-state="checked"] svg': {
            fill: theme.palette.common.white,
        }, cursor: 'pointer' }, styles));
});
var Indicator = styled(RadioGroup.Indicator)(function (_a) {
    var theme = _a.theme, indicatorStyles = _a.indicatorStyles;
    return (__assign({ borderRadius: '100%', position: 'absolute', inset: '0px', backgroundColor: 'var(--circle-select-color)' }, indicatorStyles));
});
var Label = styled('label')({
    fontSize: '1.2rem',
    fontFamily: 'Roboto',
    textAlign: 'center',
    position: 'absolute',
    bottom: '-40px',
    width: '100%',
});
var Icon = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'absolute',
        inset: '0px',
        display: 'grid',
        placeItems: 'center',
    });
});
var ErrorMessage = styled(FormHelperText)(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        textAlign: 'center',
        position: 'relative',
        top: '45px',
    });
});
var MotionItem = motion(Item);
var variants = {
    down: { scale: 0.8 },
    rest: { scale: 1 },
};
var AnimatedItem = function (_a) {
    var value = _a.value, children = _a.children, color = _a.color, itemStyles = _a.itemStyles, _b = _a.onClick, onClick = _b === void 0 ? function () { return null; } : _b;
    var _c = useState(false), isDown = _c[0], setIsDown = _c[1];
    var handleMouseDown = function () {
        setIsDown(true);
    };
    var handleMouseUp = function () { return setIsDown(false); };
    useEffect(function () {
        if (!isDown)
            return;
        var timeout = setTimeout(function () { return setIsDown(false); }, 2000);
        return function () { return clearTimeout(timeout); };
    }, [isDown]);
    return (_jsx(MotionItem, __assign({ color: color, animate: isDown ? 'down' : 'rest', variants: variants, value: value, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp, onMouseLeave: handleMouseUp, onTouchStart: handleMouseDown, onTouchEnd: handleMouseUp, styles: itemStyles, onClick: onClick, type: undefined, className: 'group' }, { children: children })));
};
